import { render } from "./knowledgebase-details.vue?vue&type=template&id=d2230e2e"
import script from "./knowledgebase-details.vue?vue&type=script&lang=js"
export * from "./knowledgebase-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__